import { unitOfMeasureUrl } from "../Config/Url";
import axios from "axios";

export const unitOfMeasureServices = {
  getById,
  getSearch,
  create,
  update,
  deleteUnitOfMeasure,
};

async function getById(unitOfMeasureId) {
  return axios
    .get(`${unitOfMeasureUrl}/${unitOfMeasureId}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getSearch({ searchText, pageIndex, pageSize, sortName, isAsc }) {
  return axios
    .put(`${unitOfMeasureUrl}/search`, {
      searchText,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create({ name, tag }) {
  return axios
    .post(`${unitOfMeasureUrl}`, { name, tag })
    .then((res) => res)
    .catch((err) => err.response);
}

async function update({ unitOfMeasureId, name, tag }) {
  return axios
    .put(`${unitOfMeasureUrl}/${unitOfMeasureId}`, { name, tag })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteUnitOfMeasure(unitOfMeasureId) {
  return axios
    .delete(`${unitOfMeasureUrl}/${unitOfMeasureId}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}
